import { createSvgIcon } from '@material-ui/core';

export const GroupSystemIcon = createSvgIcon(
  <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M19.9895 22.6667L25.3333 13.3439L19.9895 4H9.34381L4 13.3439L9.34381 22.6667H19.9895Z"
      fill="#4E6980"
    />
    <path
      d="M19.9895 44L25.3333 34.6773L19.9895 25.3333H9.34381L4 34.6773L9.34381 44H19.9895Z"
      fill="#4E6980"
    />
    <path
      d="M38.6562 33.3333L44 24.0106L38.6562 14.6667H28.0105L22.6667 24.0106L28.0105 33.3333H38.6562Z"
      fill="#4E6980"
    />
  </svg>,
  'GroupSystemIcon',
);
